import React from 'react';
import { CustomerAddress } from '../../../../types/customers';
import { SectionHeader } from '../../../common';
import Address from './Address';
import styled from 'styled-components/macro';
import { WithTranslation, withTranslation } from 'react-i18next';
import EditAddressModal from './EditAddressModal';
import { Button } from '../../../../components/Buttons';
import { State } from '../reducer';
import AddAddressModal from './AddAddressModal';

interface AddressesSectionProps extends WithTranslation {
    accountId: string;
    customerId: string;
    addresses: CustomerAddress[];
    addressesState: State;
    openEditModal: (index: number) => void;
    closeEditModal: () => void;
    editCustomerAddresses: (accountId: string, id: string, values: CustomerAddress[]) => void;
    addCustomerAddresses: (accountId: string, id: string, values: CustomerAddress[]) => void;
    openAddModal: () => void;
    closeAddModal: () => void;
}

const AddressesSection = (
    {
        accountId,
        customerId,
        addresses,
        addressesState,
        t,
        openEditModal,
        closeEditModal,
        openAddModal,
        closeAddModal,
        editCustomerAddresses,
        addCustomerAddresses,
    }: AddressesSectionProps
) => {
    const editingIndex = addressesState.editing.index;
    const isAdding = addressesState.adding.isAdding;

    const saveEditedAddresses = (index: number, values: CustomerAddress) => {
        const updatedAddresses = addresses.map((address, i) => {
            if (index === i) return values;
            return address;
        });
        editCustomerAddresses(accountId, customerId, updatedAddresses);
    };

    const deleteAddress = (index: number) => {
        const updatedAddresses = addresses.filter((a, i) => i !== index);
        editCustomerAddresses(accountId, customerId, updatedAddresses);
    };

    const saveAddedAddress = (values: CustomerAddress) => {
        const updatedAddresses = addresses.concat(values);
        addCustomerAddresses(accountId, customerId, updatedAddresses);
    };

    return (
        <>
            <Container>
                <SectionHeader>
                    {t('customers.customer.addresses.title.default_entity', { count: addresses.length })}
                </SectionHeader>
                <AddressContainer>
                    {addresses.map((address, i) => (
                        <Address
                            key={i}
                            index={i}
                            address={address}
                            onDelete={() => deleteAddress(i)}
                            onEdit={() => openEditModal(i)}
                        />
                    ))}
                </AddressContainer>

                <ButtonContainer>
                    <Button onClick={openAddModal}>{t('customers.customer.addresses.add')}</Button>
                </ButtonContainer>
            </Container>
            {editingIndex !== null && (
                <EditAddressModal
                    closeModal={closeEditModal}
                    accountId={accountId}
                    customerId={customerId}
                    index={editingIndex}
                    address={addresses[editingIndex]}
                    saveAddresses={saveEditedAddresses}
                />
            )}
            {isAdding && (
                <AddAddressModal
                    accountId={accountId}
                    customerId={customerId}
                    closeModal={closeAddModal}
                    saveAddresses={saveAddedAddress}
                />
            )}
        </>
    );
};

export default withTranslation()(AddressesSection);

const Container = styled.div``;

const AddressContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 1024px) {
        flex-direction: column;
    }
`;

const ButtonContainer = styled.div`
    margin-top: 20px;
`;
